import { render, staticRenderFns } from "./MaxItem.vue?vue&type=template&id=3327daaa&scoped=true&"
import script from "./MaxItem.vue?vue&type=script&lang=js&"
export * from "./MaxItem.vue?vue&type=script&lang=js&"
import style0 from "./MaxItem.vue?vue&type=style&index=0&id=3327daaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327daaa",
  null
  
)

export default component.exports